import { Navigate, Outlet } from "react-router-dom";

import { getFallbackRoute } from "@/config/routes";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { isMockEnabled } from "@/mock/config";
import { FEATURE_FLAG } from "@/types/feature-flag";

export const SuppliesFeatureRoute = () => {
  const isEnabled = useFeatureFlag(FEATURE_FLAG.SUPPLIES);

  if (!isMockEnabled() && !isEnabled) {
    return <Navigate replace to={getFallbackRoute()} />;
  }

  return <Outlet />;
};
